import i18n from './../../../shared/i18n';
import {getPhoneRuleObj} from "@/plugins/vee-validate";

import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class AddressForm extends BaseModel {
  address_1 = '';
  address_2 = '';
  city = '';
  city_obj_uuid = '';
  state = '';
  state_obj_uuid = null;
  county = '';
  county_obj_uuid = '';
  zip_code = '';
  country_code = '';
  type = '';
  tax_rate = null;
  is_primary = false;
  email = '';
  phone = '';
  first_name = '';
  last_name = '';

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    address_1: 'required',
    city: 'required',
    country_code: 'required',
    zip_code: 'required',
    type: 'required',
    phone: getPhoneRuleObj(),
    email: 'email|max:73',
    tax_rate: 'max_value:100|min_value:0',
  };

  attributeLabels = {
    address_1: i18n.t('Address 1'),
    address_2: i18n.t('Address 2'),
    city: i18n.t('City'),
    city_obj_uuid: i18n.t('City'),
    state: i18n.t('State'),
    state_obj_uuid: i18n.t('State'),
    county: i18n.t('County'),
    county_obj_uuid: i18n.t('County'),
    zip_code: i18n.t('Zip/Postcode'),
    country_code: i18n.t('Country'),
    type: i18n.t('Type'),
    tax_rate: i18n.t('Tax Rate'),
    is_primary: i18n.t('Primary Address'),
    country: i18n.t('Country'),
    phone: i18n.t('Phone'),
    email: i18n.t('Email'),
    first_name: i18n.t('Contact First Name'),
    last_name: i18n.t('Contact Last Name'),
  };
}
